import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/industries/construction/page.tsx");
